export default [{
    name: 'question',
    path: '/question',
    component: () => import('@/views/question')
},
{
    path: '/question/add',
    component: () => import('@/views/question/add')
},
{
    path: '/question/:id',
    props: (route) => ({
        id:  Number(route.params.id)
    }),
    component: () => import('@/views/question/detail')
},
{
    path: '/question/:id/edit',
    props: (route) => ({
        id:  Number(route.params.id)
    }),
    component: () => import('@/views/question/edit')
},
    {
        path: '/question/:id/copy',
        props: (route) => ({
            id:  Number(route.params.id)
        }),
        component: () => import('@/views/question/copy')
    },
]